<template>
  <div id="productPage" class="data-list-container">
    <variant-tree
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-popup
      class="holamundo"
      title="Ürün Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Ürünü Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-table
      ref="table"
      :data="products"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="$isCenterBranch() && isNewProductPermission" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Ürün" position="top">
                    <vs-button
                      @click="addNewData"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Satış Sayfasını Yenile" position="top">
                    <vs-button
                      @click="reloadProductCache()"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-refresh-cw"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Ürün Fiyat Listesi Excel" position="top">
                  <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                             color="transparent" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-2/12">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Fotoğraf</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            class="w-5/12"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('name')"
            >İsim</vs-button
          >
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Kategori</vs-button
          >
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Mobil</vs-button
          >
        </vs-th>
        <vs-th class="w-1/12" v-if="$isCenterBranch() && isDeleteProductPermission">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >İşlem</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="img-container w-2/12">
              <img
                :src="
                  tr.imageUrl
                    ? $baseUrl + '/' + tr.imageUrl
                    : require('@/assets/images/portrait/small/profile-placeholder.png')
                "
                class="product-img"
              />
            </vs-td>

            <vs-td class="w-5/12">
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td class="w-3/12">
              <p class="font-medium truncate m-auto" style="width: fit-content">
                <template v-if="tr.categories && tr.categories.length > 0">
                  <vs-chip v-for="category in tr.categories" :key="category.id">{{
                    category.name
                  }}</vs-chip>
                </template>
                <template v-else-if="tr.category && tr.category.name">
                  <vs-chip>{{ tr.category.name }}</vs-chip>
                </template>
                <template v-else-if="tr.categoryName">
                  <vs-chip>{{ tr.categoryName }}</vs-chip>
                </template>
                <template v-else>
                  <vs-chip color="warning">Kategorisiz</vs-chip>
                </template>
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap w-1/12">
              <vx-tooltip v-if="tr.isShowMobileMainScreen" text="Mobil Anasayfada Gösteriliyor" position="top">
                <feather-icon icon="SmartphoneIcon" svgClasses="w-5 h-5 text-success stroke-current" />
              </vx-tooltip>
            </vs-td>

            <vs-td class="whitespace-no-wrap w-1/12" v-if="$isCenterBranch() && isDeleteProductPermission">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import PaginationDefault from "../PaginationDefault";
import GlobalFilter from "../GlobalFilter";
import VariantTree from "./VariantTree.vue";
import moduleProduct from "@/store/product/moduleProduct.js";
import { deleteProduct } from "@/api/Product";
import { reloadProductCache } from "@/api/SelfService";
import {GetAllProductsPriceExcel} from "@/api/Reports";
import {isGranted} from "@/utils/auth";
export default {
  components: {
    VariantTree,
    PaginationDefault,
    GlobalFilter,
  },
  data() {
    return {
      deletedId: null,
      deletePopupActive: false,
      selected: "",

      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      addNewDataSidebar: false,
      sidebarData: {},

      isFilterActive: false,
      filterOptions: ["branch", "product", "category", "isShowMobileMainScreen"],
      filterOptionNames: ["Şube", "Ürün", "Kategori", "Mobil Anasayfa"],
      filterChips: [],
    };
  },
  computed: {
    products() {
      return this.$store.state.product.products;
    },
    totalDataRow() {
      return this.$store.state.product.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    isNewProductPermission(){
      return isGranted("product_write")
    },
    isDeleteProductPermission(){
      return isGranted("product_delete")
    }
  },
  methods: {
    getExcel() {
      GetAllProductsPriceExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Ürün Fiyat Listesi' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    reloadProductCache() {
      reloadProductCache()
        .then((res) => {
          if (res.status === 200) {
            this.$vs.notify({
              color: "success",
              title: "Yenileme Başarılı",
              text: "Satış Sayfası Başarıyla Yenilendi",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status || 500,
              text: "Ürün Silme Başarısız !",
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Yenileme Başarısız",
            text: "Satış Sayfası Yenileme Başarısız !",
          });
        });
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Index",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: null,
        product: null,
        category: null,
        isShowMobileMainScreen: false,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    escape() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      deleteProduct(id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$store.dispatch("product/removeProduct", id).then(() => {
              this.deletePopupActive = false;
              this.$vs.notify({
                color: "success",
                title: "Silme İşlemi",
                text: "Ürün Başarıyla Silindi",
              });
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status || 500,
              text: "Ürün Silme Başarısız !",
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Silme İşlemi",
            text: "Ürün Silme Başarısız !",
          });
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getProductList() {
      this.$store
        .dispatch("product/fetchDataListItemsProduct", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    if (!moduleProduct.isRegistered) {
      this.$store.registerModule("product", moduleProduct);
      moduleProduct.isRegistered = true;
    }
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getProductList();
        });
      },
    },
    selected: function (val) {
      if (val != "" && this.$isCenterBranch() && this.isNewProductPermission) this.editData(val);
    },
    currentPage: function () {
      this.tableOptions.pageIndex = this.currentPage;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
.vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}

#productPage .vs-con-table .vs-table tr td.img-container span {
  justify-content: center !important;
}
</style>
